/* <flux-sfeerbanner> — vervaagt de achtergrondfoto op het moment dat de
   meereizende kop stopt en de voordelen eronder in beeld komen.

   De kop ([data-kop]) is sticky binnen een vlak ([data-reis]). Zolang hij
   meereist is de foto scherp; zodra hij de onderkant van dat vlak raakt,
   stopt hij en gaat de vervaging aan. Scrol je terug, dan reist hij weer mee
   en wordt de foto weer scherp. Een IntersectionObserver op de lijst viel
   niet precies samen met dat stopmoment, dus we meten het zelf, één keer per
   frame tijdens het scrollen.

   De sectie wordt gerenderd met data-vervaagd="true": zonder JavaScript blijft
   de foto vervaagd en de tekst leesbaar. De overgang zelf is CSS (transition
   op filter), dus prefers-reduced-motion wordt daar afgehandeld. */

class FluxSfeerbanner extends HTMLElement {
  connectedCallback() {
    this.reis = this.querySelector('[data-reis]');
    this.kop = this.querySelector('[data-kop]');
    if (!this.reis || !this.kop) return;

    this.gepland = false;
    this.bijwerken = () => {
      if (this.gepland) return;
      this.gepland = true;
      requestAnimationFrame(() => {
        this.gepland = false;
        this.meet();
      });
    };

    window.addEventListener('scroll', this.bijwerken, { passive: true });
    window.addEventListener('resize', this.bijwerken, { passive: true });
    this.meet();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.bijwerken);
    window.removeEventListener('resize', this.bijwerken);
  }

  meet() {
    const reis = this.reis.getBoundingClientRect();
    const onderrand = reis.bottom - parseFloat(getComputedStyle(this.reis).paddingBottom);
    // De kop kan niet voorbij de inhoudsrand van het vlak: raakt hij die, dan
    // is hij gestopt.
    const gestopt = this.kop.getBoundingClientRect().bottom >= onderrand - 1;
    this.dataset.vervaagd = gestopt ? 'true' : 'false';
  }
}

if (!customElements.get('flux-sfeerbanner')) customElements.define('flux-sfeerbanner', FluxSfeerbanner);
